import * as React from 'react';
import LighthouseReview from 'src/app/page/LighthouseReview';

/**
 * Props for the CaseViewerModal component.
 */
export interface CaseViewerModalProps {
    /** The review ID to display. */
    reviewId: string;
    /** Whether the modal is visible. */
    visible: boolean;
    /** Whether the review is read-only (View) or editable (Reopen). */
    readOnly?: boolean;
    /** Callback when the modal is closed (via X button or backdrop click). */
    onClose: () => void;
}

/**
 * CaseViewerModal
 *
 * A full-page overlay that opens the Lighthouse Review page in read-only popup mode.
 * Used by the Management (CaseAudit) page to let supervisors view a case
 * without navigating away from their dashboard.
 */
const CaseViewerModal: React.FC<CaseViewerModalProps> = ({reviewId, visible, readOnly = true, onClose}) => {
    if (!visible) return null;

    return (
        <div className="case-viewer-overlay" data-testid="case-viewer-modal">
            <div className="case-viewer-header">
                <span className="case-viewer-title">Case Review: {reviewId}</span>
                <button className="case-viewer-close" onClick={onClose} data-testid="case-viewer-close">&times;</button>
            </div>
            <div className="case-viewer-modal-body" data-testid="case-viewer-modal-body">
                <LighthouseReview
                    reviewId={reviewId}
                    mode="popup"
                    readOnly={readOnly}
                    onClose={onClose}
                />
            </div>
        </div>
    );
};

export default CaseViewerModal;
